import { render, staticRenderFns } from "./AddUserForm.vue?vue&type=template&id=a861449a&"
import script from "./AddUserForm.vue?vue&type=script&lang=ts&"
export * from "./AddUserForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports